 <!-- Shopping Cart Icon with Badge -->
 <nz-badge [nzCount]="numberOfItems">
    <span nz-icon nzType="shopping-cart" class="text-xl" nzTheme="outline"></span>
  </nz-badge>